import { FormItemBase } from './form-item-base';

export class FormItemTitle extends FormItemBase<string> {
  controlType = 'title';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    const key = 'type';

    this.labelClass = 'form-item-depth-' + this.depth.toString();
  }
}
